import actionTypes from './action-types';
import * as api from '../resources/message.api';

export const fetchRecipientsRequest = () => ({
  type: actionTypes.FETCH_RECIPIENTS_REQUEST,
  name: 'recipientsLoadingStatus',
});

export const fetchRecipientsFailure = () => ({
  type: actionTypes.FETCH_RECIPIENTS_FAILURE,
  name: 'recipientsLoadingStatus',
});

export const fetchRecipientsSuccess = (recipients, pagination) => ({
  type: actionTypes.FETCH_RECIPIENTS_SUCCESS,
  recipients,
  pagination,
  name: 'recipientsLoadingStatus',
});

export const fetchRecipients = (params) => async (dispatch) => {
  try {
    dispatch(fetchRecipientsRequest());
    const { content, ...pagination } = await api.fetchRecipients(params);

    dispatch(fetchRecipientsSuccess(content, pagination));
  } catch (error) {
    dispatch(fetchRecipientsFailure(error));
    console.error('FETCH_RECIPIENTS', error);
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/actions/recipients.actions.js